import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/sites/$siteID/leaks')({
  component: () => <div>Hello /sites/$siteID/leaks!</div>
})

// show leaks for all stations (devrait p-e etre la meme chose que prélèvements ? ) on consolide les 2
